<template>
    <div class="col-12">
      <div class="search-padd">
        <div class="col-xs-12 override-padding">
          <div class="crm_admin_heading account_heading_1 text-left">+/-</div>
          <div class="crm_admin_heading account_heading_2 text-left">Account Name</div>
          <div class="crm_admin_heading account_heading_3 text-left">Address</div>
          <div class="crm_admin_heading account_heading_4 text-left">City</div>
          <div class="crm_admin_heading account_heading_5 text-left">State</div>
          <div class="crm_admin_heading account_heading_6 text-left">Postal Code</div>
          <div class="crm_admin_heading account_heading_7 text-left">Phone</div>
          <div class="crm_admin_heading account_heading_8 text-left">&nbsp;&nbsp;</div>
          <div class="crm_admin_heading account_heading_9 text-center">Status</div>
          <div class="crm_admin_heading account_heading_10 text-left">Exp</div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div v-if="enterprise_accounts.length > 0">
          <div v-for="(enterprise_account, index) in enterprise_accounts" :key="index" class="accounts_items">
            <div v-bind:class="'enterprise_account_' + index" v-bind:id="'account_details_more_' + index">
              <div class="crm_admin_field_lists account_heading_1 text-center font-weight-bold line-height-30">
                <a v-b-toggle="'collapse_' + index">
                  <span class="when-opened">-</span> <span class="when-closed">+</span>
                </a>
              </div>
              <div class="crm_admin_field_lists account_heading_2 text-left">
                  {{ enterprise_account.accountName }}
              </div>
              <div class="crm_admin_field_lists account_heading_3 text-left">
                {{ enterprise_account.address }}
              </div>
              <div class="crm_admin_field_lists account_heading_4 text-left">
                  {{ enterprise_account.city }}
              </div>
              <div class="crm_admin_field_lists account_heading_5 text-left">
                {{ enterprise_account.state }}
              </div>
              <div class="crm_admin_field_lists account_heading_6 text-left">
                {{ enterprise_account.zip }}
              </div>
              <div class="crm_admin_field_lists account_heading_7 text-left">
                {{ enterprise_account.phoneNumber + " " + enterprise_account.phoneExt }}
              </div>
              <div class="crm_admin_field_lists account_heading_8 text-center link_name font-weight-bold" v-on:click="router_redirect(enterprise_account.accountId)">
                View Account
              </div>
              <div :class="'crm_admin_field_lists account_heading_9 text-center font-weight-bold ' + getStatusColor(enterprise_account.status)">
                {{ enterprise_account.status }}
              </div>
              <div class="crm_admin_field_lists account_heading_10 text-left">
                {{ enterprise_account.expirationDate }}
              </div>
            </div>
            <div style="clear: both;"></div>
            <b-collapse v-bind:id="'collapse_' + index" class="">
              <!-- Users start -->
              <div v-bind:class="'admin_details' + index" v-bind:id="'user_details_more' + index">
                  <div
                      class="user-title">
                      <a v-b-toggle="'users_collapse_' + index">
                      Users <span class="when-opened">-</span> <span class="when-closed">+</span>
                      </a>
                  </div>
                  <b-collapse v-bind:id="'users_collapse_' + index" @shown="getUsersInfo(enterprise_account.accountId, index)">
                      <EnterpriseAccountUsersHeader
                          :ref="'account_user_results_header_' + index">
                      </EnterpriseAccountUsersHeader>
                  </b-collapse>
              </div>
              <!-- Users end -->
            </b-collapse>
          <div style="clear: both; margin-top: 10px;"></div>
          </div>
        </div>
        <div v-else>
          <div class="col-12 no_records_msg">No Account Found</div>
        </div>
        <form v-on:submit.prevent class="mt-1">
          <div v-for="(account, index) in enterprise_new_accounts" :key="index" :v-if="loading === false">
            <div v-bind:class="'account_details' + index" v-bind:id="'account_details_more' + index">
              <div class="">
                <div
                  class="crm_admin_field_lists new_account_heading_1 text-align-center font-25 line-height-30">
                  <a v-b-toggle="'new_account_collapse_' + index" class="cursor-pointer">
                    <span class="when-opened">-</span> <span class="when-closed">+</span>
                  </a>
                </div>
              </div>
              <div class="crm_admin_field_lists new_account_heading_2 text-align-left">
                <div class="search-padd">
                  <input
                      type="text"
                      v-bind:id="'account_name_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      ref="account_name"
                      v-bind:name="'account_name[' + index + ']'"
                      v-model="account.company_name"
                      v-validate="'required'"
                      placeholder="Account Name"
                      maxlength="250"
                      autocomplete="off">
                  <div v-if="verrors.firstByRule('account_name[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Account name is required</div>
                  <div v-if="verrors.firstByRule('account_name[' + index + ']', 'exists')" class="margin-bottom-5 validate-warning-msg">Account name already exists</div>
                </div>
              </div>
              <div class="crm_admin_field_lists new_account_heading_3 text-align-left">
                <div class="search-padd">
                  <input
                      type="text"
                      v-bind:id="'account_city_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      ref="account_city"
                      v-bind:name="'account_city[' + index + ']'"
                      v-model="account.location.city"
                      placeholder="City"
                      maxlength="250"
                      autocomplete="off">
                </div>
              </div>
              <div class="crm_admin_field_lists new_account_heading_4 text-align-left">
                <div class="search-padd">
                  <b-form-select
                    v-bind:name="'account_state[' + index + ']'"
                    v-bind:id="'account_state_' + index"
                    class="col-12 col-sm-12 ma-input-field"
                    v-model="account.location.state_code"
                    :options="state_options">
                    </b-form-select>
                </div>
              </div>
              <div class="crm_admin_field_lists new_account_heading_5 text-align-left">
                <div class="search-padd">
                  <input
                    type="text"
                    v-bind:name="'account_zipcode[' + index + ']'"
                    v-bind:id="'account_zipcode_' + index"
                    class="col-12 col-sm-12 ma-input-field"
                    ref="zipcode"
                    v-model="account.location.zip"
                    placeholder="Postal Code"
                    v-validate="{ rules: { regex: getPostalCodeRegex() } }"
                    maxlength="10">
                  <div v-if="verrors.has('account_zipcode[' + index + ']')" class="margin-bottom-5 validate-warning-msg">Postal code is invalid</div>
                </div>
              </div>
              <div class="crm_admin_field_lists new_account_heading_6 text-align-left">
                <div class="search-padd">
                  <input
                    type="text"
                    v-bind:name="'account_phone[' + index + ']'"
                    v-bind:id="'account_phone_' + index"
                    class="col-12 col-sm-12 ma-input-field"
                    ref="phone"
                    v-model="account.phone_no"
                    placeholder="Phone No"
                    @keyup="phoneValid($event, index)"
                    @blur="phoneValid($event, index)"
                    v-validate="{ rules: { regex: accountPhoneRegex() } }"
                    maxlength="14">
                  <div v-if="verrors.has('account_phone[' + index + ']')" class="margin-bottom-5 validate-warning-msg">Phone Number is invalid</div>
                </div>
              </div>
              <div class="crm_admin_field_lists new_account_heading_7 text-align-left">
                <div class="search-padd">
                  <b-form-select
                    v-bind:name="'account_status[' + index + ']'"
                    v-bind:id="'account_status_' + index"
                    class="col-12 col-sm-12 ma-input-field"
                    v-model="account.status"
                    :options="status_options">
                    </b-form-select>
                </div>
              </div>
              <div class="crm_admin_field_lists new_account_heading_8 text-align-center">
                <div
                  class="search-padd delete-icon" style=""
                  v-if="enterprise_new_accounts.length > 0">
                    <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeAccount(index)"></i>
                </div>
              </div>
            </div>
            <b-collapse v-bind:id="'new_account_collapse_' + index" class=""></b-collapse>
            <div style="clear: both; margin-top: 10px;"></div>
          </div>
        </form>
        <div class="row mt-4">
          <div class="col-12">
            <button
                v-on:click="addAccount()"
                class="btn btn-red btn-group-sm"
                >
                <b><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>New Account</b>
            </button>
            <button
                v-on:click="isLinkAccountModalVisible=true"
                class="btn btn-red btn-group-sm"
                >
                <b>Link Account</b>
            </button>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <DeleteModal :isModalVisible="isDeleteModalVisible" :id="delete_id" :parent_id="parent_id" @close="isDeleteModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">Are you sure you want to delete?</div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-3 override-padding">
            <button class="left col-12 btn btn-red" @click="isDeleteModalVisible = false; deleteAdminAction(delete_id)">Confirm</button>
          </div>
        </DeleteModal>

        <LinkAccountModal 
          :enterpriseId="accountId"
          :isModalVisible="isLinkAccountModalVisible" 
          @close="isLinkAccountModalVisible = false"
          >
        </LinkAccountModal>

        <NewAccountModal 
          :enterpriseId="accountId"
          :isModalVisible="isNewAccountModalVisible"
          ref="new_account_modal_form" 
          @close="isNewAccountModalVisible = false"
          >
        </NewAccountModal>

      </div>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import moment from 'moment';
import router from '../../router/index.js';
import EnterpriseAccountUsersHeader from './enterprise_account_user_header.vue';
import DeleteModal from '../shared/delete_modal_alert.vue';
import LinkAccountModal from './link_account_modal.vue';
import NewAccountModal from './new_account_modal.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
      props: ['accountId', 'program', 'accountStatus'],
      data() {
        return {
          enterprise_accounts: [],
          enterprise_new_accounts: [],
          loading: false,
          updated_enterprise_accounts: {},
          account_status_options: [
            { value: 'Active', text: 'Active' },
            { value: 'Inactive', text: 'Inactive' },
            { value: 'Prospect', text: 'Prospect' }
          ],
          state_options:  [],
          status_options: [
            { value: '', text: 'Select Status' },
            { value: 'Active', text: 'Active' },
            { value: 'Inactive', text: 'Inactive' },
            { value: 'Prospect', text: 'Prospect' },
          ],
          isDeleteModalVisible: false,
          parent_id: '',
          delete_id: '',
          isLinkAccountModalVisible: false,
          isNewAccountModalVisible: false,
        }
      },
      components: {
          EnterpriseAccountUsersHeader,
          DeleteModal,
          LinkAccountModal,
          NewAccountModal
      },
      methods: {
        nameRegex: function() {
          return /^[\w- ']*$/;
        },
        getStatusColor(status) {
            if (status == "Active") {
                return 'text_green';
            } else if(status == "Inactive") {
                return 'text_red';
            } else {
                return '';
            }
        },
        getUsersInfo(accountId, index) {
          this.$refs['account_user_results_header_' + index][0].getAccountUsers(accountId);
        },
        addAccount: function() {
          this.$refs.new_account_modal_form.verrors.clear();
          this.isNewAccountModalVisible=true;
        },
        getAccountsListData: function() {
            this.loading = false;
            this.enterprise_new_accounts = [];
            axios.get('/enterprise/linked-accounts/' + this.accountId, {

            })
            .then(response =>  {
              this.enterprise_accounts = response.data;
              //console.log(this.enterprise_accounts)
            })
            .catch(function(error) {

            });
        },
        router_redirect: function(accountId) {
          let routeData = this.$router.resolve({name: 'accountlookupdetail', params: {account_id: accountId}});
          window.open(routeData.href, '_blank');
        },
        getStateLists: function (CountryCode) {
          axios.get('/get-state-lists/' + CountryCode, {

          })
          .then(response =>  {
            this.state_options = response.data;
          })
          .catch(function(error) {

          });
        },
        phoneValid: function(event, index) {
          var phone = event.target.value;
          this.enterprise_new_accounts[index].phone_no = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        accountPhoneRegex: function() {
          return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        getPostalCodeRegex() {
          return /^[0-9]{5}(?:-[0-9]{4})?$/;
        },
        removeAccount: function(index) {
          this.isDeleteModalVisible = true;
          this.delete_id = index;
        },
        deleteAdminAction: function(index) {
          this.enterprise_new_accounts.splice(index, 1);
        }
      },
      created: function () {
        this.loading = true;
        this.getAccountsListData(); 
        this.getStateLists('US');   
      },
    }
</script>
<style scoped>
.account_heading_1 { width: 3%; }
.account_heading_2 { width: 15%; }
.account_heading_3 { width: 15%; }
.account_heading_4 { width: 8%; }
.account_heading_5 { width: 8%; }
.account_heading_6 { width: 10%; }
.account_heading_7 { width: 13%; }
.account_heading_8 { width: 10%; }
.account_heading_9 { width: 10%; }
.account_heading_10 { width: 8%; }
.new_account_heading_1 { width: 3% }
.new_account_heading_2 { width: 24% }
.new_account_heading_3 { width: 12% }
.new_account_heading_4 { width: 13% }
.new_account_heading_5 { width: 15% }
.new_account_heading_6 { width: 15% }
.new_account_heading_7 { width: 15% }
.new_account_heading_8 { width: 3% }
.accounts_items:nth-child(odd) {
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  background-color: #FFFFFF !important;
  color: #707070;
}
.accounts_items:nth-child(even) {
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  background-color: #e9e9e9 !important;
  color: #707070;
}
.text_green {
    color: #4ea959 !important;
}
.text_red {
    color: #ff0000 !important;
}
.link_name, .link_name:focus { color: #00ACEE !important; text-decoration: none; cursor:pointer; }
.user-title {
  color: #707070;
  font-weight: 900;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  min-height: 38px;
}
.no_records_msg {
  background: #FFFFFF none repeat scroll 0 0 !important;
  border-bottom: 2px solid #ddd;
  border-top: 0 none;
  color: #FF0000;
  float: left;
  line-height: 1.42857;
  padding: 8px 3px;
  vertical-align: bottom;
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/enterprise_lookup_accounts_tab.vue